<template>
  <div class="wrap">
    <nav-header
      id="special_head"
      ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showNavbar="p_showNavbar"
      v-bind:showCart="p_showCart"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
     <nav-bread>
      <span slot="goods">全部商品</span>
      <span slot="detail">商品详情</span>
    </nav-bread>
    <div class="coupons_bannerImg">
    </div>
    <div class="coupons_banner">
      <div class="coupons_banner_wrap">
        <router-link to="/mine/myCoupons">我的优惠券</router-link>
        <a @click="rulesDetailHandle()">优惠券使用规则 >></a>
      </div>
    </div>
    <div class="coupons_wrap" v-if="couponsList.length!=0">
      <div class='list'>
        <div v-for='(item, index) in couponsList' class="coupon_each">
          <div class='coupon' v-if='Percentage((item.total*10000-item.receive*10000)/10000,item.total) != "0%"'>
            <div class='coupon_left'>
              <div class='tip' v-if='item.rules == "{}"'>
                <img :src='jbImg.green'>
                <div class='txt'>通</div>
              </div>
              <div :class='item.rules == "{}" ? "price" : "price1"' v-if='item.couponType == 0'>
                <div class='txt2' v-if='numberLength(item.value) <= 3'><span class='txt1'>￥</span>{{item.value}}</div>
                <div class='txt2' v-if='numberLength(item.value) > 3' style='font-size:40px;top:10px'><span class='txt1'>￥</span>{{item.value}}</div>
              </div>
              <div class='price_discount' v-if='item.couponType == 1'>
                <div class='txt1'>{{discountCoupon(item.value, 10)}}<span class='txt2'>折</span></div>
              </div>
              <div class='detail'>
                <div class='detail_title'>{{item.title}}</div>
                <div class='detail_desc'>
                  <div class='txt3' v-if='item.amount == 0'>无门槛</div>
                  <div class='txt3' v-else>消费满{{item.amount}}可用</div>
                  <div class='txt4' v-if='item.rangeType == 1 && item.isShowBeginDate'>有效期从{{getCurrentTime(item.rangeBeginTime)}}至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 1 && !item.isShowBeginDate'>有效期至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 0'>领取后{{item.rangeExpiry}}天内有效</div>
                </div>
              </div>
            </div>
            <div class='coupon_right'
              @click="getCoupon(item.id, item.userMax)"
              v-if='item.isReceive == null || (item.isReceive >=0 && item.isReceive < item.userMax)'>
            <!-- <div class='coupon_right' v-if='item.isReceive == null || (item.isReceive >=0 && item.isReceive < item.userMax)' bindtap='getCoupon' data-id='{{item.id}}' data-user-max='{{item.userMax}}'>   -->
              <div>{{ item.couponId }}</div>
              <div class='percent'>{{Percentage((item.total*10000-item.receive*10000)/10000,item.total)}}</div>
              <div class='progress'>
                <img :src='greenImg.hundred' v-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 90  && percentNum((item.total*10000-item.receive*10000)/10000,item.total) <= 100'>
                <img :src='greenImg.ninety' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 80'>
                <img :src='greenImg.eighty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 70'>
                <img :src='greenImg.seventy' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 60'>
                <img :src='greenImg.sixty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 50'>
                <img :src='greenImg.fifty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 40'>
                <img :src='greenImg.forty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 30'>
                <img :src='greenImg.thirty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 20'>
                <img :src='greenImg.twenty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 10'>
                <img :src='greenImg.ten' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) > 0'>
              </div>
              <div class='btn' v-if='item.isReceive == 0 || item.isReceive == null'>立即领取</div>
              <div class='btn' v-else-if='item.isReceive > 0 && item.isReceive < item.userMax'>继续领取</div>
            </div>
            <div class='coupon_right' v-else>
              <div class='percent_grey'>
                {{Percentage((item.total*10000-item.receive*10000)/10000,item.total)}}
              </div>
              <div class='progress'>
                <img :src='greyImg.hundred' v-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 90  && percentNum((item.total*10000-item.receive*10000)/10000,item.total) <= 100'>
                <img :src='greyImg.ninety' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 80'>
                <img :src='greyImg.eighty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 70'>
                <img :src='greyImg.seventy' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 60'>
                <img :src='greyImg.sixty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 50'>
                <img :src='greyImg.fifty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 40'>
                <img :src='greyImg.forty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 30'>
                <img :src='greyImg.thirty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 20'>
                <img :src='greyImg.twenty' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) >= 10'>
                <img :src='greyImg.ten' v-else-if='percentNum((item.total*10000-item.receive*10000)/10000,item.total) > 0'>
              </div>
              <div class='btn_grey'>已领取</div>
            </div>
          </div>
          <div class='coupon_grey' v-else>
            <div class='coupon_left'>
              <div class='tip' v-if='item.rules == "{}"'>
                <img :src='jbImg.grey'>
                <div class='txt'>通</div>
              </div>
              <div :class='item.rules == "{}" ? "price" : "price1"' v-if='item.couponType == 0'>
                <div class='txt2' v-if='numberLength(item.value) <= 3'><span class='txt1'>￥</span>{{item.value}}</div>
                <div class='txt2' v-if='numberLength(item.value) > 3' style='font-size:40px;top:10px'><span class='txt1'>￥</span>{{item.value}}</div>
              </div>
              <div class='price_discount' v-if='item.couponType == 1'>
                <div class='txt1'>{{discountCoupon(item.value,10)}}<span class='txt2'>折</span></div>
              </div>
              <div class='detail'>
                <div class='detail_title'>【{{item.providerName}}】{{item.title}}</div>
                <div class='detail_desc'>
                  <div class='txt3' v-if='item.amount == 0'>无门槛</div>
                  <div class='txt3' v-else>消费满{{item.amount}}可用</div>
                  <div class='txt4' v-if='item.rangeType == 1 && item.isShowBeginDate'>有效期从{{getCurrentTime(item.rangeBeginTime)}}至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 1 && !item.isShowBeginDate'>有效期至:{{getCurrentTime(item.rangeEndTime)}}</div>
                  <div class='txt4' v-if='item.rangeType == 0'>领取后{{item.rangeExpiry}}天内有效</div>
                </div>
              </div>
            </div>
            <div class='coupon_right'>
              <div class='percent'>0%</div>
              <div class='progress'>
                <img :src='greyImg.zero'>
              </div>
              <div class='btn'>已抢完</div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="totalCount"
        v-if="couponsList.length"
        style="text-align:center;margin-top:50px;background-color:#F8F8F8">
      </el-pagination>
      <!-- <div class="weui-loadmore" v-if='couponsList.length'>
        <div class="weui-loadmore__tips" style='opacity:0.5'>---我是有底线的---</div>
      </div> -->
    </div>
    <div class="coupons_wrap" v-if="couponsList.length===0" style="background-color:#fff;">
      <div style="width:400px;margin:0 auto;text-align:center;">
        <img src="../assets/mycoupons_empty.png">
        <p>暂无优惠券</p>
      </div>
    </div>
    <!-- 规则 -->
    <rules-detail v-if="rulesDetailVisible" ref="rulesDetail"></rules-detail>
  </div>
</template>

<script>
import NavHeader from '@/components/Header'
import NavBread from '@/components/Bread'
// import NavFooter from '@/components/Footer'
// import RulesDetail from '../../components/rules-detail'
import RulesDetail from '@/components/coupons-rules-detail'

import {getCookie, removeHTMLTag, delCookie, Percentage, getCurrentTime} from "../util/util"



import axios from 'axios'

export default {
  name: 'CouponsCenter',
  components: {
    NavHeader,
    NavBread,
    RulesDetail
    // NavFooter,
    // RulesDetail
  },
  data () {
    return {
      // header
      p_showSearch: true,
      p_loginModalFlag: false,
      p_showNavbar: true,
      p_showCart: true,

      couponsList: [],
      rulesDetailVisible: false,
      totalCount: 0,
      currentPage: 1,
      limit: 9,
      page: 1,

      providerId: this.$store.state.providerId || localStorage.getItem("providerId") || '',

      jbImg:{
        'green':'https://pic.jianyanwang.com/upload/20181126/bc448451fdb04948baa69ccc6ded84ae.png',
        'grey': 'https://pic.jianyanwang.com/upload/20181126/b1b843cee3af44eca9a473b3a5ed9f68.png'
      },
      greenImg:{
        'ten':'https://pic.jianyanwang.com/upload/20180910/0eec567b8ddc4dd6bb97ad238e2d171c.png',
        'twenty':'https://pic.jianyanwang.com/upload/20180910/c54f4b6eb4e04153a1d718b4fb422552.png',
        'thirty':'https://pic.jianyanwang.com/upload/20180910/3476a26864444d0bbc362be279b86d18.png',
        'forty':'https://pic.jianyanwang.com/upload/20180910/bed08d7f01a741a18c222484f092e13c.png',
        'fifty':'https://pic.jianyanwang.com/upload/20180910/86fcbebaebcb4501ae85c54692a10cfe.png',
        'sixty':'https://pic.jianyanwang.com/upload/20180910/741d3dfb9c82447487ab3ce82e31bcf8.png',
        'seventy':'https://pic.jianyanwang.com/upload/20180910/6db26d7ac2fd444ba8a799e50d41709b.png',
        'eighty':'https://pic.jianyanwang.com/upload/20180910/09b2a76a088a45beb0267d5ad1c6bd41.png',
        'ninety':'https://pic.jianyanwang.com/upload/20180910/e9c50505bdc941bba21a28cb293d5921.png',
        'hundred':'https://pic.jianyanwang.com/upload/20180910/3a89f88e06c7495fb9765d7fa586b8b7.png'
      },
      greyImg:{
        'zero':'https://pic.jianyanwang.com/upload/20180910/494b3b6becd142a8b77acbe7439da417.png',
        'ten':'https://pic.jianyanwang.com/upload/20180910/8fa789a4cb4c4ab79e258c239f14b444.png',
        'twenty':'https://pic.jianyanwang.com/upload/20180910/67a7b72bd14e411598a78dc0b0516f5f.png',
        'thirty':'https://pic.jianyanwang.com/upload/20180910/f53d37edb6d34e1985d74ea741213ca3.png',
        'forty':'https://pic.jianyanwang.com/upload/20180910/72262d24148a4a298aac46811525c0ca.png',
        'fifty':'https://pic.jianyanwang.com/upload/20180910/0b03042ad4d94b0981f089ad67b4fdb2.png',
        'sixty':'https://pic.jianyanwang.com/upload/20180910/963127e06c77404bb301f52c7b6a4971.png',
        'seventy':'https://pic.jianyanwang.com/upload/20180910/91abdc6fdd7744c48fb3b939b8572629.png',
        'eighty':'https://pic.jianyanwang.com/upload/20180910/6c702aa216094733bd1e2530c754ede1.png',
        'ninety':'https://pic.jianyanwang.com/upload/20180910/d2179d31739a4f5c9a9445495ce13891.png',
        'hundred':'https://pic.jianyanwang.com/upload/20180910/fb85d95aeef646c285b5076aaf2c2c97.png'
      },
    }
  },
  computed: {
    getCurrentTime () {
      return function (time) {
        return getCurrentTime(time)
      }
    }
  },
  mounted () {
    if (getCookie("_token")) {
      this.getCouponsList()
    } else {
      this.getCouponsList_unlogin()
    }
  },
  methods: {
    Percentage(number1, number2) {
      return (Math.round(number1/(number2) * 1000) / 10.00 + "%");
    },
    numberLength (number) {
      return number.toString().length
    },
    discountCoupon (number1, number2) {
      return (Math.round( (number1 / number2 ) * 10) / 10)
    },
    percentNum (number1, number2) {
      return (Math.round(number1 / (number2) * 1000) / 10.00);
    },
    getDate: function (time, splitStr) {
      if (!time) return ''
      var date = getDate(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();

      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;

      if (splitStr)
        return y + splitStr + M + splitStr + d;
      else
        // return {
        //   y: y,
        //   M: M,
        //   d: d
        // };
        return y + '年' + M + '月' + d + '日';
    },

    p_showLoginModal() {
      this.p_loginModalFlag = true
    },
    p_closeLoginModal() {
      this.p_loginModalFlag = false
    },
    // 未登录时获取优惠券
    getCouponsList_unlogin(){
      axios.get('/ai/coupon/nologin/page', {
        params: {
          platform:'ZYJY',
          shopId: this.providerId,
          limit: this.limit,
          page: this.page
        }
      }).then((res) => {
        if (res.data.code == 0) {
          var couponsList = res.data.page.records
          this.couponsList = res.data.page.records
          this.currentPage = res.data.page.current
          this.totalCount = res.data.page.total
          var curDate = new Date().getTime()
          for (var i = 0; i < couponsList.length; i++) {
            if (couponsList[i].rangeEndTime) {
              couponsList[i].rangeEndTime = couponsList[i].rangeEndTime.replace(/-/g, '/')
              couponsList[i].rangeBeginTime = couponsList[i].rangeBeginTime.replace(/-/g, '/')
              var endDate = Date.parse(new Date(couponsList[i].rangeEndTime))
              var beginDate = Date.parse(new Date(couponsList[i].rangeBeginTime))
              if ((beginDate - curDate) > 0) {
                couponsList[i].isShowBeginDate = true
              } else {
                couponsList[i].isShowBeginDate = false
              }
            }
          }
        }
      })
    },
    //已经登录时获取优惠券
    getCouponsList(){
      axios.get('/ai/coupon/page', {
        params: {
          platform:'ZYJY',
          shopId: this.providerId,
          limit: this.limit,
          page: this.page
        }
      }).then((res) => {
        if(res.data.code == 0){
          console.log('res', res)
          this.couponsList = res.data.page.records
          this.currentPage = res.data.page.current
          this.totalCount = res.data.page.total

          var couponsList = res.data.page.records
          var curDate = new Date().getTime()
          for (var i = 0; i < couponsList.length; i ++){
            if (couponsList[i].rangeEndTime){
              couponsList[i].rangeEndTime = couponsList[i].rangeEndTime.replace(/-/g, '/')
              couponsList[i].rangeBeginTime = couponsList[i].rangeBeginTime.replace(/-/g, '/')
              var endDate = Date.parse(new Date(couponsList[i].rangeEndTime))
              var beginDate = Date.parse(new Date(couponsList[i].rangeBeginTime))
              if ((beginDate - curDate) > 0) {
                couponsList[i].isShowBeginDate = true
              } else {
                couponsList[i].isShowBeginDate = false
              }
            }
          }
        }
      })
    },
      // 领券
    getCoupon(couponId, userMax) {
      if (!getCookie("_token")) {
        // console.log('未登录')
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        })
        this.p_showLoginModal()
      } else {
        // console.log('领取')
        axios.post('/ai/coupon/' + couponId).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: '领取成功',
              type: 'success'
            })
            this.getCouponsList()
          }
        }).catch((err) => {
          this.$message.error('领取失败')
        })
      }
    },
    // 优惠券使用规则
    rulesDetailHandle () {
      this.rulesDetailVisible = true
      this.$nextTick(() => {
        this.$refs.rulesDetail.init()
      })
    },
    handleCurrentChange (val) {
      console.log('val', val)
      this.page = val
      if (getCookie("_token")) {
        this.getCouponsList()
      } else {
        this.getCouponsList_unlogin()
      }
    }
  }
}
</script>

<style scoped>
/* PC */
/* loadmore */
.weui-loadmore {
  width: 65%;
  margin: 3.5em auto;
  line-height: 1.6em;
  font-size: 14px;
  text-align: center;
}

.weui-loadmore__tips {
  display: inline-block;
  vertical-align: middle;
  color: #888;
}

/* main */
.coupons_wrap {
  padding-bottom: 50px;
  background-color: #F8F8F8 ;
}

.coupons_main {
  display: flex;
  width: 100%;
}

.regulation{
  width:100%;
  height:72px;
  line-height: 72px;
  background: #F5F5F5;
  text-align: center;
}
.regulation text{
  padding-right: 30px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #576B95;
}

.list{
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  /* margin-top: 40px; */
  margin: 0 auto;
}

.coupon_each {
  flex: 0 0 33%;
}

.list .coupon,
.list .coupon_grey{
  display: flex;
  width: 93%;
  /* width: 670px; */
  height: 130px;
  margin: 0 auto;
  background :#FFFFFF;
  margin-top: 40px;
  box-shadow:3px 3px 20px #d8d8d8;
}


.list .coupon .coupon_left,
.list .coupon_grey .coupon_left{
  width: 75%;
  height: 100%;
  /* overflow: hidden; */
  position: relative;
  display: flex;
}
.list .coupon .coupon_left .tip,
.list .coupon_grey .coupon_left .tip{
  width: 50px;
  height: 50px;
  position: absolute;
}
.list .coupon .coupon_left .tip img,
.list .coupon_grey .coupon_left .tip img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0
}
.list .coupon .coupon_left .tip .txt,
.list .coupon_grey .coupon_left .tip .txt{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  position: absolute;
  top: 3px;
  left: 6px;
  /* z-index: 99 */
}
.list .coupon .coupon_left .price,
.list .coupon_grey .coupon_left .price{
  width: 50%;
  height: 100%;
}
.list .coupon .coupon_left .price .txt1,
.list .coupon_grey .coupon_left .price .txt1{
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #00C5B0;
  /* padding-left: 28px; */
}
.list .coupon .coupon_left .price .txt2,
.list .coupon_grey .coupon_left .price .txt2{
  font-family: DINCondensed-Bold;
  font-size: 50px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  height: 100%;
  line-height: 240%;
  text-align: center;
  /* padding-left: 12px; */
}
.list .coupon .coupon_left .price1,
.list .coupon_grey .coupon_left .price1{
  width: 50%;
  height: 100%;
  float: left;
  position: relative
}
.list .coupon .coupon_left .price1 .txt1,
.list .coupon_grey .coupon_left .price1 .txt1{
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #00C5B0;
  /* padding-left: 28px; */
}
.list .coupon .coupon_left .price1 .txt2,
.list .coupon_grey .coupon_left .price1 .txt2{
  height: 100%;
  line-height: 240%;
  text-align: center;
  font-family: DINCondensed-Bold;
  font-size: 50px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  /* padding-left: 12px; */
  /* margin-left:60px; */
}
.list .coupon .coupon_left .price_discount,
.list .coupon_grey .coupon_left .price_discount{
  display: flex;
  align-items: right;
  width: 50%;
  height: 100%;
  line-height: 200%;
}
.list .coupon .coupon_left .price_discount .txt1,
.list .coupon_grey .coupon_left .price_discount .txt1{
  width: 100%;
  height: 100%;
  line-height: 250%;
  font-family: DINCondensed-Bold;
  font-size: 50px;
  color: #00C5B0;
  letter-spacing: -1.87px;
  text-align: center;
}
.list .coupon .coupon_left .price_discount .txt2,
.list .coupon_grey .coupon_left .price_discount .txt2{
  font-family: PingFangSC-Semibold;
  font-size: 1.4rem;
  color: #00C5B0;
  margin-left: 0.6rem;
  font-weight: bold;
}
.list .coupon .coupon_left .detail,
.list .coupon_grey .coupon_left .detail{
  width: 50%;
  height:100%;
}

.list .coupon .coupon_left .detail .detail_title,
.list .coupon_grey .coupon_left .detail .detail_title{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353535;
  line-height: 15px;
  margin:30px 0 5px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.list .coupon .coupon_left .detail  .detail_desc text,
.list .coupon_grey .coupon_left .detail  .detail_desc text{
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #888888;
  /* line-height: 22px; */
}

.list .coupon .coupon_right,
.list .coupon_grey .coupon_right{
    width: 25%;
    height: 100%;
    text-align: center;
    position: relative;
    border-left:4px dotted #ddd;
    cursor: pointer;
}
.list .coupon .coupon_right::before,
.list .coupon .coupon_right::after,
.list .coupon_grey .coupon_right::before,
.list .coupon_grey .coupon_right::after{
    content: '';
    width: 24px;
    height: 24px;
    position: absolute;
    left: -12px;
    background: #f5f5f5;
    border-radius:12px;
}
.list .coupon .coupon_right::before,
.list .coupon_grey .coupon_right::before{
    top:-12px;
    box-shadow: inset 0 -4px 6px #d8d8d8;
}
.list .coupon .coupon_right::after,
.list .coupon_grey .coupon_right::after{
    bottom:-12px;
    box-shadow: inset 0 4px 6px #d8d8d8;

}
.list .coupon .coupon_right .progress,
.list .coupon_grey .coupon_right .progress{
  width: 32px;
  height: 65px;
  margin:0 auto;

}
.list .coupon .coupon_right .progress img,
.list .coupon_grey .coupon_right .progress img{
  width: 24px;
  height: 65px;
}
.list .coupon .coupon_right .percent,
.list .coupon_grey .coupon_right .percent{
  width:100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #00C5B0;
  text-align: center;
  line-height: 12px;
  margin-top: 12px;
}
.list .coupon .coupon_right .percent_grey,
.list .coupon_grey .coupon_right .percent_grey{
  width:100%;
  font-family: PingFangSC-Medium;
  font-size: 8px;
  color: #B2B2B2;
  text-align: center;
  line-height: 12px;
  margin-top: 12px;
}
.list .coupon .coupon_right .btn,
.list .coupon_grey .coupon_right .btn{
  width: 75%;
  height: 22px;
  line-height: 22px;
  margin:0 auto;
  margin-top: 5px;
  background: #FE2042;
  border-radius: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  border-color: #FE2042;
  letter-spacing: 0;
  font-weight: 300;
}
.list .coupon .coupon_right .btn_grey,
.list .coupon_grey .coupon_right .btn_grey{
  width: 75%;
  height: 22px;
  line-height: 22px;
  margin:0 auto;
  margin-top: 5px;
  background: #B2B2B2;
  border-radius: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
}

/*已抢完的优惠券*/
.list .coupon_grey{
  background: #F5F5F5;
}

.list .coupon_grey .coupon_left .price .txt1,
.list .coupon_grey .coupon_left .price1 .txt1,
.list .coupon_grey .coupon_left .price_discount .txt1,
.list .coupon_grey .coupon_left .price .txt2,
.list .coupon_grey .coupon_left .price1 .txt2,
.list .coupon_grey .coupon_left .price_discount .txt2,
.list .coupon_grey .coupon_left .detail .detail_title,
.list .coupon_grey .coupon_left .detail  .detail_desc text,
.list .coupon_grey .coupon_right .percent{
  color: #B2B2B2;
}

.list .coupon_grey .coupon_right .btn{
  background: #E2E2E2;
  color: #B2B2B2;
  border-color: #E2E2E2;
}

.index_icon{
  width:124px;
  height: 124px;
  position:fixed;
  right:15px;
  bottom:130px;
  z-index: 999;
}
.index_icon .icon_img{
  width:124px;
  height: 124px;
}
/* 底部按钮 */
.footer{
  width:100%;
  height:146px;
  position:fixed;
  z-index: 111;
  bottom:0px;
  background-image: linear-gradient(-180deg, rgba(255,255,255,0.00) 0%, #FFFFFF 13%);
}
.footer .footer_btn,.footer .footer_btn[disabled] {
  width:690px;
  height:96px;
  line-height: 96px;
  margin-left: 30px;
  margin-top:25px;
  background: #00C5B0;
  box-shadow: 0 2px 4px 0 rgba(0,197,176,0.30);
  border-radius: 3px;
  float: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
}

.coupons .coupon_img{
  width: 40px;
  height: 40px;
  position: absolute;
  top:20px;
  right: 10px;
}

.coupons_bannerImg {
  width: 100%;
  height: 200px;
  background: url("../assets/coupons_banner.png") center no-repeat;
  background-size: cover;
}

.coupons_banner {
  height: 30px;
  line-height: 30px;
  color: #00C5B0;
  font-weight: 600;
}

.coupons_banner_wrap {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;

}

.coupons_banner a:first-child {
  margin-right: 50px;
}

/deep/ .el-pagination .btn-prev,
.el-pagination button:disabled,
.el-pagination .btn-next {
  background-color: #F8F8F8;
}

/deep/.pagination .el-pager li.active,
/deep/.pagination .el-pager li,
/deep/.el-pagination .btn-next
{
  background-color: #F8F8F8;
}

/deep/.pagination .el-pager li:hover
{
  background-color:#00C5B0;
  color: #fff;
  cursor: pointer;
}

</style>

<style scoped>
@media only screen and (min-width: 310px) and (max-width: 767px) {
  .coupon_each {
    flex: 1 0 100%;
  }

  .coupons_bannerImg {
    width: 100%;
    height: 110px;
    background-image: url("../assets/coupons_banner_mobile.png");
    background-repeat: no-repeat;
    background-size: 100% 110px;
    margin-top: 32px;
  }

  .list{
    width: 100%;
  }

  .list .coupon .coupon_left,
  .list .coupon_grey .coupon_left {
    display: flex;
    height: 100%;
    position: relative;
    justify-content: space-between;
  }

  .list .coupon .coupon_left .price_discount,
  .list .coupon_grey .coupon_left .price_discount{
    display: flex;
    text-align: center;
    /* width: 100%; */
    height: 100%;
    line-height: 333%;
    margin-right: 0;
  }

  .list .coupon .coupon_left .price_discount .txt1,
  .list .coupon_grey .coupon_left .price_discount .txt1{
    width: 100%;
    height: 100%;
    line-height: 333%;
    font-family: DINCondensed-Bold;
    font-size: 3.2rem;
    color: #00C5B0;
    letter-spacing: -1.87px;
    text-align: center;
  }

  .list .coupon .coupon_right,
  .list .coupon_grey .coupon_right{
    width: 40%;
    height: 100%;
    text-align: center;
    position: relative;
    border-left:4px dotted #ddd;
    cursor: pointer;
  }

  .list .coupon .coupon_left .detail .detail_title,
  .list .coupon_grey .coupon_left .detail .detail_title{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #353535;
    line-height: 15px;
    margin: 30px 0 25px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .list .coupon .coupon_left .price .txt1,
  .list .coupon_grey .coupon_left .price .txt1{
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #00C5B0;
  }

  .list .coupon .coupon_left .price .txt2,
  .list .coupon_grey .coupon_left .price .txt2{
    height: 100%;
    line-height: 333%;
    font-family: DINCondensed-Bold;
    font-size: 3.2rem;
    color: #00C5B0;
    letter-spacing: -1.87px;
    text-align: center;
  }

  .txt3, .txt4 {
    font-size: 12px;
  }

  .list .coupon .coupon_left .price1,
  .list .coupon_grey .coupon_left .price1{
    height: 100%;
    margin-right: 3%;
    position: relative
  }

  .list .coupon .coupon_left .price1 .txt1,
  .list .coupon_grey .coupon_left .price1 .txt1{
    font-family: PingFangSC-Semibold;
    font-size: 1.8rem;
    color: #00C5B0;
  }

  .list .coupon .coupon_left .price1 .txt2,
  .list .coupon_grey .coupon_left .price1 .txt2{
    font-family: DINCondensed-Bold;
    font-size: 3.2rem;
    color: #00C5B0;
    letter-spacing: -1.87px;
    height: 100%;
    line-height: 333%;
    text-align: center;
  }

  /*已抢完的优惠券*/
  .list .coupon_grey{
    background: #F5F5F5;
  }

  .list .coupon_grey .coupon_left .price .txt1,
  .list .coupon_grey .coupon_left .price1 .txt1,
  .list .coupon_grey .coupon_left .price_discount .txt1,
  .list .coupon_grey .coupon_left .price .txt2,
  .list .coupon_grey .coupon_left .price1 .txt2,
  .list .coupon_grey .coupon_left .price_discount .txt2,
  .list .coupon_grey .coupon_left .detail .detail_title,
  .list .coupon_grey .coupon_left .detail  .detail_desc text,
  .list .coupon_grey .coupon_right .percent{
    color: #B2B2B2;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/couponsCenter.vue